import { useCallback } from "react"
import { copyToClipboard, getSubmit } from "@ui-seeker/utils"
import { isLoadingApiKey } from "Pages/Admin/Users/@signals"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"

export default function useRequestUserApiKey() {

	const { showToast } = useToast()

	const onRequestApiKey = useCallback(id => {
		isLoadingApiKey.value = id
		getSubmit(`${BACKEND_APIS.MASTER_DATA}/admin/options/api-key`, { uid: id })
			.then(({ apiKey }) => {
				copyToClipboard(apiKey)
				showToast.success("Successfully copied to clipboard!")
				isLoadingApiKey.value = null
			})
			.catch(() => {
				showToast.error("Error retrieving api key")
				isLoadingApiKey.value = null
			})
	}, [])

	return {
		onRequestApiKey
	}
}